// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__zUqAZ","major":"Home_major__1hGxt","infotitle":"Home_infotitle__KDpqc","infodescription":"Home_infodescription__1ARlL"};